const AddGalleryPhotoSvg = ({
  height = 27,
  width = 27,
  viewBox = '0 0 27 27',
}: {
  height?: number;
  width?: number;
  viewBox?: string;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox}>
      <path
        d="M3 27C2.175 27 1.46875 26.7062 0.88125 26.1187C0.29375 25.5312 0 24.825 0 24V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H15C15 0.425 15 0.8875 15 1.3875C15 1.8875 15 2.425 15 3H3V24H24V12C24.575 12 25.1125 12 25.6125 12C26.1125 12 26.575 12 27 12V24C27 24.825 26.7062 25.5312 26.1187 26.1187C25.5312 26.7062 24.825 27 24 27H3ZM4.5 21H22.5L16.875 13.5L12.375 19.5L9 15L4.5 21ZM21 9V6H18V3H21V0H24V3H27V6H24V9H21Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AddGalleryPhotoSvg;
